import Grid2 from "@mui/material/Grid2";
import { FC } from "react";

import { GameCard, GameGridSkeleton, NoData } from "@/components/Casino";
import { Game } from "@/types";

import { GameListProps } from "./type";

/** Two providers can use the same game code, so the code alone does not name a card. */
export const gameKey = (game: Game): string => `${game.providerId}:${game.gid}`;

export const GameList: FC<GameListProps> = ({ loading, gameItems, empty }) => {
  if (loading) {
    return <GameGridSkeleton />;
  }

  if (gameItems?.length === 0) {
    return empty ?? <NoData />;
  }

  return (
    <Grid2 container columnSpacing={2} rowSpacing={{ xs: 1, sm: 2 }}>
      {gameItems.map((game) => (
        <GameCard key={gameKey(game)} {...game} />
      ))}
    </Grid2>
  );
};
